import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';

function Parcelas({ data, onDataChange, itens }) {
  const { user } = useAuth();
  const [parcelas, setParcelas] = useState(data || []);

  // Obtém a quantidade de casas decimais do usuário (padrão = 2 se não encontrado)
  const casasDecimais = user?.matriz?.casasDecimaisValorUnitario ?? 2;

  // Formata um valor garantindo que seja um número válido
  const formatarValor = (valor) => {
    const numero = Number(valor);
    if (isNaN(numero)) return '0,00'; // Se não for número, retorna "0,00"
    return numero.toFixed(casasDecimais).replace('.', ',');
  };

  // Formata a data para DD/MM/YYYY
  const formatarData = (dataISO) => {
    if (!dataISO) return '';
    const data = new Date(dataISO);
    if (isNaN(data)) return ''; // Caso a data seja inválida
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Mês é baseado em zero
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  // Atualiza o valor das parcelas ao mudar os itens
  useEffect(() => {
    if (!itens || itens.length === 0) {
      setParcelas([]);
      return;
    }

    const valorTotal = itens.reduce((acc, item) => acc + (Number(item.total) || 0), 0);

    if (parcelas.length > 0) {
      const valorPorParcela = valorTotal / parcelas.length || 0;

      const novasParcelas = parcelas.map((parcela) => ({
        ...parcela,
        valor: valorPorParcela,
      }));

      setParcelas(novasParcelas);
      if (onDataChange) onDataChange(novasParcelas);
    }
  }, [itens]);

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ overflow: 'auto' }}>
        <Table sx={{ minWidth: 600 }}>
          <TableHead>
            <TableRow>
              <TableCell align="center">Nro</TableCell>
              <TableCell align="center">Data Vencimento</TableCell>
              <TableCell align="center">Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parcelas.map((parcela, index) => (
              <TableRow key={index}>
                <TableCell align="center">{parcela.numero}</TableCell>
                <TableCell align="center">{formatarData(parcela.dataVencimento)}</TableCell>
                <TableCell align="center">{formatarValor(parcela.valor)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}

export default Parcelas;
